import { ensureSuccess } from "@utils/assertion";
import { type InstantSearchResult } from "@newgenerated/shared/schema";
import { serialize_InstantSearchResult, deserialize_InstantSearchResult } from "@newgenerated/shared/serializerDeserializer/InstantSearchResult";

export { type InstantSearchResult } from "@newgenerated/shared/schema";
export const parseInstantSearchResult = (data: unknown): InstantSearchResult => {
  return ensureSuccess(deserialize_InstantSearchResult(JSON.stringify(data)));
};
export const renderInstantSearchResult = (data: InstantSearchResult): any => {
  return JSON.parse(serialize_InstantSearchResult(data));
};
